export const CONTRATS_PER_PAGE = 50
export const USER_ID = 'websecretaire-user-id'
export const AUTH_TOKEN = 'websecretaire-token'



// WEBPACK FOOTER //
// ./src/constants/settings.js